import {configureStore, combineReducers} from "@reduxjs/toolkit"
import {useDispatch as useStoreDispatch} from "react-redux"
import staff from "./features/staff/staffSlice"
import client from "./features/client/clientSlice"
import application from "./features/applications/applicationSlice"
import report from "./features/report/reportSlice"
import basicMenu from "./features/basic-menu/basicMenuSlice"
import auth from "./features/auth/authSlice"
import {cityApi} from "./features/сity/cityApi"
import {branchApi} from "./features/branch/branchApi"
import {permissionApi} from "./features/permission/permissionApi"
import {setAuthTokenGetter} from "./utils/http"

export type StoreState = ReturnType<typeof adminReducer>

export const adminReducer = combineReducers({
    basicMenu,
    staff,
    client,
    application,
    report,
    auth,
    [permissionApi.reducerPath]: permissionApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer
})

export type AppDispatch = typeof store.dispatch

export interface AppThunkProps {
    dispatch: AppDispatch
    state: StoreState
    extra?: unknown
    rejectValue?: unknown
}

export const useDispatch = () => useStoreDispatch<any>()

export const store = configureStore({
    reducer: adminReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({immutableCheck: false})
            .concat(cityApi.middleware)
            .concat(branchApi.middleware)
            .concat(permissionApi.middleware)
})

// Отдаём http-слою доступ к актуальному токену из store (без циклических импортов)
setAuthTokenGetter(() => store.getState().auth.token)
